const BASE_URL = import.meta.env.VITE_API_URL;

// API calls
const sendFormDataApi = async (data) => {
  const res = await fetch(`${BASE_URL}api/v1/surveys`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  const resData = await res.json();

  return {
    status: res.status,
    ok: res.ok,
    data: resData,
  };
};

const sendFileApi = async (data) => {
  const { id, formData } = data;

  return fetch(`${BASE_URL}api/v1/surveys/${id}/upload-file`, {
    method: 'POST',
    body: formData,
  }).then((res) => res.json());
};

const fetchReportDataApi = async (pageId) => {
  const res = await fetch(`${BASE_URL}api/v1/surveys/by-page-id/${pageId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await res.json();
  return {
    status: res.status,
    ok: res.ok,
    data,
  };
};

const fetchReferenceDataApi = async () => {
  const res = await fetch(`${BASE_URL}api/v1/reference-data`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await res.json();
  return {
    status: res.status,
    ok: res.ok,
    data,
  };
};

const fetchModulesDataApi = async (referenceData) => {
  const res = await fetch(`${BASE_URL}api/v1/modules/by-type-and-domain`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(referenceData),
  });

  const data = await res.json();
  return {
    status: res.status,
    ok: res.ok,
    data,
  };
};

const sendContactFormDataApi = async (data) => {
  const res = await fetch(`${BASE_URL}api/v1/get-in-touch`, {
    method: 'POST',
    body: data,
  });

  const resData = await res.json();

  return {
    status: res.status,
    ok: res.ok,
    data: resData,
  };
};

const fetchCountApi = async () => {
  const res = await fetch(`${BASE_URL}api/v1/surveys/count`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  const data = await res.json();
  return {
    status: res.status,
    ok: res.ok,
    data,
  };
};

export {
  fetchReportDataApi,
  sendContactFormDataApi,
  sendFormDataApi,
  sendFileApi,
  fetchReferenceDataApi,
  fetchModulesDataApi,
  fetchCountApi,
};
